import { memo } from 'react';
import { useDataContext } from 'src/contexts';

import { DefaultLoader } from './components/Loader';
import { Particles } from './components/Particles';
import {
  useInitialize,
  usePvoUploadStatus,
  useStartRecordingStatus,
} from './hooks';
import { MainPage } from './pages/main';

import './styles/index.css';

const App = memo(function App() {
  const { isLoading: isInitializeLoading } = useInitialize();
  usePvoUploadStatus();
  useStartRecordingStatus();

  const isLoading = useDataContext((ctx) => ctx.isLoading);
  const pwId = useDataContext((ctx) => ctx.playwallId);

  const isInitialLoading = isInitializeLoading || !pwId;

  return (
    <>
      <Particles />
      <DefaultLoader isLoading={isInitialLoading || isLoading} />
      {!isInitialLoading && <MainPage />}
    </>
  );
});

export default App;
